module.exports = __webpack_public_path__ + "static/search2-7b737d3b9046f135b4621c558789dafa.png";